








import VueOptions from '@utils/VueOptions'

settings = 
  name: 'DebugOnly'

export default VueOptions.vue settings
